var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54 19.5201C4.93 19.5201 4.36 19.31 3.95 18.92C3.43 18.43 3.18 17.69 3.27 16.89L3.64 13.65C3.71 13.04 4.08 12.23 4.51 11.79L12.72 3.10005C14.77 0.930049 16.91 0.870049 19.08 2.92005C21.25 4.97005 21.31 7.11005 19.26 9.28005L11.05 17.97C10.63 18.42 9.85 18.84 9.24 18.9401L6.02 19.49C5.85 19.5 5.7 19.5201 5.54 19.5201ZM15.93 2.91005C15.16 2.91005 14.49 3.39005 13.81 4.11005L5.6 12.8101C5.4 13.0201 5.17 13.5201 5.13 13.8101L4.76 17.05C4.72 17.38 4.8 17.65 4.98 17.82C5.16 17.99 5.43 18.05 5.76 18L8.98 17.4501C9.27 17.4001 9.75 17.14 9.95 16.93L18.16 8.24005C19.4 6.92005 19.85 5.70005 18.04 4.00005C17.24 3.23005 16.55 2.91005 15.93 2.91005Z",
    fill: "#00365A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.34 10.95C17.32 10.95 17.29 10.95 17.27 10.95C14.15 10.64 11.64 8.27005 11.16 5.17005C11.1 4.76005 11.38 4.38005 11.79 4.31005C12.2 4.25005 12.58 4.53005 12.65 4.94005C13.03 7.36005 14.99 9.22005 17.43 9.46005C17.84 9.50005 18.14 9.87005 18.1 10.28C18.05 10.66 17.72 10.95 17.34 10.95Z",
    fill: "#00365A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22.75H3C2.59 22.75 2.25 22.41 2.25 22C2.25 21.59 2.59 21.25 3 21.25H21C21.41 21.25 21.75 21.59 21.75 22C21.75 22.41 21.41 22.75 21 22.75Z",
    fill: "#00365A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEdit);
export default __webpack_public_path__ + "static/media/blue-edit.f190678dde125c4710bbb0c7f4e723f3.svg";
export { ForwardRef as ReactComponent };